import React from 'react';
import { Phone, CheckCircle, BarChart2, Users, Award, Search } from 'lucide-react';
import Container from '../Container';
import Button from '../Button';

const GenericLanding = () => {
  const benefits = [
    'Guaranteed First Page Rankings',
    'Local SEO Optimization',
    'Monthly Performance Reports',
    'Dedicated Account Manager',
    'No Long-Term Contracts',
    '24/7 Support'
  ];

  const stats = [
    {
      icon: BarChart2,
      value: '300%',
      label: 'Average Traffic Increase'
    },
    {
      icon: Users,
      value: '500+',
      label: 'Satisfied Clients'
    },
    {
      icon: Award,
      value: '15+',
      label: 'Years Experience'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <Container>
        <div className="pt-32 pb-20">
          <div className="max-w-3xl mx-auto text-center mb-12">
            <div className="inline-flex items-center bg-blue-100 text-blue-600 px-4 py-2 rounded-full mb-6">
              <Search className="h-5 w-5 mr-2" />
              Raleigh's Top-Rated SEO Agency
            </div>

            <h1 className="text-5xl font-bold text-gray-900 mb-6">
              Transform Your Online Presence with
              <span className="text-blue-600"> Expert SEO</span>
            </h1>

            <p className="text-xl text-gray-600 mb-4">
              Join 500+ successful businesses in Raleigh already dominating their markets
            </p>

            <a href="tel:9192714871" className="flex items-center justify-center text-2xl text-blue-600 font-bold mb-8 hover:text-blue-700">
              <Phone className="h-6 w-6 mr-2" />
              (919) 271-4871
            </a>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            {stats.map((stat, index) => (
              <div 
                key={index}
                className="bg-white p-8 rounded-xl shadow-lg text-center"
              >
                <stat.icon className="h-12 w-12 text-blue-600 mx-auto mb-4" />
                <div className="text-4xl font-bold text-gray-900 mb-2">{stat.value}</div>
                <p className="text-gray-600">{stat.label}</p>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">
                Why Choose SEO Raleigh?
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {benefits.map((benefit, index) => (
                  <div key={index} className="flex items-center">
                    <CheckCircle className="h-5 w-5 text-blue-600 mr-2" />
                    <span className="text-gray-700">{benefit}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-xl p-8">
              <h2 className="text-2xl font-bold text-center mb-6">Get Your Free SEO Analysis</h2>
              <form className="space-y-4">
                <input
                  type="text"
                  placeholder="Business Name"
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
                <input
                  type="text"
                  placeholder="Website URL"
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
                <input
                  type="email"
                  placeholder="Email Address"
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
                <input
                  type="tel"
                  placeholder="Phone Number"
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
                <Button className="w-full text-lg py-4">
                  Get Free Analysis
                </Button>
              </form>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default GenericLanding;